/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DueDateDto } from './DueDateDto';
import {
    DueDateDtoFromJSON,
    DueDateDtoFromJSONTyped,
    DueDateDtoToJSON,
    DueDateDtoToJSONTyped,
} from './DueDateDto';
import type { RenegotiationDto } from './RenegotiationDto';
import {
    RenegotiationDtoFromJSON,
    RenegotiationDtoFromJSONTyped,
    RenegotiationDtoToJSON,
    RenegotiationDtoToJSONTyped,
} from './RenegotiationDto';

/**
 * Special conditions of a borrower contract
 * @export
 * @interface BorrowerContractSpecialConditionsDto
 */
export interface BorrowerContractSpecialConditionsDto {
    /**
     * Insurance project type label
     * @type {string}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    insuranceProjectType?: string | null;
    /**
     * Insurance project type code
     * @type {string}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    insuranceProjectTypeCode?: string | null;
    /**
     * Payment frequency label
     * @type {string}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    paymentFrequency?: string | null;
    /**
     * Payment frequency code
     * @type {string}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    paymentFrequencyCode?: string | null;
    /**
     * Start date of the special conditions
     * @type {Date}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {DueDateDto}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    dueDate?: DueDateDto;
    /**
     * 
     * @type {RenegotiationDto}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    renegotiation?: RenegotiationDto;
    /**
     * IBAN of the associated bank account
     * @type {string}
     * @memberof BorrowerContractSpecialConditionsDto
     */
    bankAccountIban?: string | null;
}

/**
 * Check if a given object implements the BorrowerContractSpecialConditionsDto interface.
 */
export function instanceOfBorrowerContractSpecialConditionsDto(value: object): value is BorrowerContractSpecialConditionsDto {
    return true;
}

export function BorrowerContractSpecialConditionsDtoFromJSON(json: any): BorrowerContractSpecialConditionsDto {
    return BorrowerContractSpecialConditionsDtoFromJSONTyped(json, false);
}

export function BorrowerContractSpecialConditionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractSpecialConditionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuranceProjectType': json['insuranceProjectType'] == null ? undefined : json['insuranceProjectType'],
        'insuranceProjectTypeCode': json['insuranceProjectTypeCode'] == null ? undefined : json['insuranceProjectTypeCode'],
        'paymentFrequency': json['paymentFrequency'] == null ? undefined : json['paymentFrequency'],
        'paymentFrequencyCode': json['paymentFrequencyCode'] == null ? undefined : json['paymentFrequencyCode'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'dueDate': json['dueDate'] == null ? undefined : DueDateDtoFromJSON(json['dueDate']),
        'renegotiation': json['renegotiation'] == null ? undefined : RenegotiationDtoFromJSON(json['renegotiation']),
        'bankAccountIban': json['bankAccountIban'] == null ? undefined : json['bankAccountIban'],
    };
}

export function BorrowerContractSpecialConditionsDtoToJSON(json: any): BorrowerContractSpecialConditionsDto {
    return BorrowerContractSpecialConditionsDtoToJSONTyped(json, false);
}

export function BorrowerContractSpecialConditionsDtoToJSONTyped(value?: BorrowerContractSpecialConditionsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuranceProjectType': value['insuranceProjectType'],
        'insuranceProjectTypeCode': value['insuranceProjectTypeCode'],
        'paymentFrequency': value['paymentFrequency'],
        'paymentFrequencyCode': value['paymentFrequencyCode'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString()),
        'dueDate': DueDateDtoToJSON(value['dueDate']),
        'renegotiation': RenegotiationDtoToJSON(value['renegotiation']),
        'bankAccountIban': value['bankAccountIban'],
    };
}

